import Client from "./Clients/AxiosClient";
const resource = "/api";

export default {
  addBroadcastMessage(message) {
    return Client.post(`${resource}/Broadcast`, message, {
      withCredentials: true,
      responseType: "json",
      headers: { "Content-Type": "application/json" }
    });
  },
  getBroadcastMessage(userid) {
    return Client.get(`${resource}/Broadcast/` + userid, {
      withCredentials: true,
      responseType: "json",
      headers: { "Content-Type": "application/json" }
    });
  },
};
